/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs'

const $nsid = 'chat.bsky.convo.listConvos'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  kind: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['direct', 'group'] }>(),
  ),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['request', 'accepted'] }>(),
  ),
  readState: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['unread'] }>(),
  ),
  lockStatus: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['unlocked', 'locked', 'locked-permanently']
    }>(),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convos: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
      (() => ConvoDefs.convoView) as any,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a page of conversations (direct or group) for the user. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
